import React from "react";
import { View } from "@/styles/reactnative";
import { CButton } from "@app/components/Common/";
import { COLORS } from "@app/constants/";
import { useTranslation } from "react-i18next";

interface IProps {
  choose?: string;
  setChoose?: any;
}

const TransactionChoice = ({ choose, setChoose }: IProps) => {
  const { t } = useTranslation();
  const choice = ["limit", "market", "tpSL"];
  return (
    <View
      style={{
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "row",
        paddingLeft: 10,
      }}
    >
      {choice?.map((item, index) => {
        return (
          <CButton
            key={index.toString()}
            title={item && t(item)}
            onClick={() => {
              setChoose(item);
            }}
            style={{
              color: choose === item ? COLORS.primary : COLORS.lightGray5,
              fontWeight: "500",
            }}
          />
        );
      })}
    </View>
  );
};

export default React.memo(TransactionChoice);
